import { useSessionTime } from 'hooks/session';

const SessionTime = () => {
  const sessionTime = useSessionTime();

  return sessionTime;
};

export default SessionTime;
